import { SubjectType } from '../../../financial/data/interfaces/price-agreement';
import {
  ExpiringAgreement,
  PriceAgreementsDashboardData
} from './types';

type MockPriceAgreement = ExpiringAgreement & {
  blocked: boolean
}

export function createPriceAgreementsMockData(): PriceAgreementsDashboardData {
  const agreements = createAgreements();
  const expireList = agreements
    .filter(agreement =>
      !agreement.blocked
      && agreement.daysUntilExpiration >= 0
      && agreement.daysUntilExpiration <= 30
    )
    .map(({ blocked, ...agreement }) => ({ ...agreement }))
    .sort((left, right) => left.daysUntilExpiration - right.daysUntilExpiration);

  return {
    summary: {
      active: agreements.filter(
        agreement => !agreement.blocked && agreement.daysUntilExpiration >= 0
      ).length,
      expiringSoon: expireList.length,
      blocked: agreements.filter(agreement => agreement.blocked).length
    },
    expireList
  };
}

function createAgreements(): MockPriceAgreement[] {
  return [
    createAgreement(3101, 'Jaarafspraak betonmortel', SubjectType.Customer, 101, 'Bouwbedrijf Noord B.V.', 'Bouwbedrijf Noord B.V.', 5, false),
    createAgreement(3102, 'Projectprijzen Stationsplein', SubjectType.Project, 502, 'Stationsplein', 'Van Dijk Infra', 12, false),
    createAgreement(3103, 'Prijsafspraak Kadeversterking', SubjectType.Project, 503, 'Kadeversterking', 'Aannemersbedrijf De IJssel', 21, false),
    createAgreement(3104, 'Raamovereenkomst Centrum', SubjectType.Customer, 104, 'Projectontwikkeling Centrum', 'Projectontwikkeling Centrum', 29, false),
    createAgreement(3105, 'Projectprijzen Viaduct Oost', SubjectType.Project, 505, 'Viaduct Oost', 'Hofman Civiele Techniek', 47, false),
    createAgreement(3106, 'Jaarafspraak Woningbouw Salland', SubjectType.Customer, 105, 'Woningbouw Salland', 'Woningbouw Salland', 96, false),
    createAgreement(3107, 'Projectprijzen Bedrijfshal', SubjectType.Project, 506, 'Bedrijfshal Deventer', 'Betonwerken Oost', 8, true),
    createAgreement(3108, 'Raamovereenkomst Ontwikkeling West', SubjectType.Customer, 108, 'Stedelijke Ontwikkeling West', 'Stedelijke Ontwikkeling West', 62, true),
    createAgreement(3109, 'Oude prijsafspraak IJssel', SubjectType.Customer, 103, 'Aannemersbedrijf De IJssel', 'Aannemersbedrijf De IJssel', -14, false),
    createAgreement(3110, 'Projectprijzen Nieuwbouw Olst', SubjectType.Project, 508, 'Nieuwbouw Olst', 'Woningbouw Salland', 180, false)
  ];
}

function createAgreement(
  id: number,
  description: string,
  subjectType: SubjectType,
  subjectId: number,
  subjectName: string,
  customerName: string,
  daysUntilExpiration: number,
  blocked: boolean
): MockPriceAgreement {
  return {
    id,
    description,
    subjectType,
    subjectId,
    subjectName,
    customerName,
    validToDate: dateWithOffset(daysUntilExpiration),
    daysUntilExpiration,
    blocked
  };
}

function dateWithOffset(days: number): string {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + days);
  return [
    String(date.getDate()).padStart(2, '0'),
    String(date.getMonth() + 1).padStart(2, '0'),
    date.getFullYear()
  ].join('-');
}
